/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * One role in an item's role set: an existing role by principal URN, or a new role by name. Set exactly one.
 */
export type ApplyDirectoryRoleSetupRole = {
  /**
   * Name of a role to create. Items in the batch that name the same new role share it.
   */
  createName?: string | undefined;
  /**
   * Principal URN of an existing role.
   */
  roleUrn?: string | undefined;
};

/** @internal */
export type ApplyDirectoryRoleSetupRole$Outbound = {
  create_name?: string | undefined;
  role_urn?: string | undefined;
};

/** @internal */
export const ApplyDirectoryRoleSetupRole$outboundSchema: z.ZodMiniType<
  ApplyDirectoryRoleSetupRole$Outbound,
  ApplyDirectoryRoleSetupRole
> = z.pipe(
  z.object({
    createName: z.optional(z.string()),
    roleUrn: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      createName: "create_name",
      roleUrn: "role_urn",
    });
  }),
);

export function applyDirectoryRoleSetupRoleToJSON(
  applyDirectoryRoleSetupRole: ApplyDirectoryRoleSetupRole,
): string {
  return JSON.stringify(
    ApplyDirectoryRoleSetupRole$outboundSchema.parse(
      applyDirectoryRoleSetupRole,
    ),
  );
}
